import { Component, Prop, Vue } from 'vue-property-decorator'
import Control from '@/helpers/control'
import fetch from '@/helpers/fetch'
import LabelModified from '@/components/edit/LabelModified/index.vue'
import BadgeClient from '@/components/checking-accounts/BadgeClient/index.vue'

import FieldMoneyPortal from '@/components/edit/FieldMoneyPortal/index.vue'
import FieldPercentagePortal from '@/components/edit/FieldPercentagePortal/index.vue'
import FieldDatePortal from '@/components/edit/FieldDatePortal/index.vue'
import onInputCheckingAccounts from '@/views/CheckingAccounts/onInputCheckingAccounts'

import tableHelper from '@/helpers/table'

@Component({
	components: {
		LabelModified,
		BadgeClient,
		FieldMoneyPortal,
		FieldPercentagePortal,
		FieldDatePortal,
	},
})
export default class TableBody extends Vue {
	@Prop() trials
	@Prop() updateMap

	status = {}
	set statusReference(value) {
		this.status = value
	}

	get statusReference() {
		return this.status
	}

	getCheckingAccounts(trial) {
		if (trial?.checkingAccounts?.[0]) {
			return trial?.checkingAccounts?.[0]
		}

		return {}
	}

	getStatusReference(trial, name) {
		const statusObj =
			this.statusReference[this.getCheckingAccounts(trial).id]

		return statusObj ? statusObj[name] : ''
	}

	updateKeys = {
		preDistributionCredit: 0,
		feePercentage: 0,
		feeAmount: 0,
		decisionDate: 0,
		calculationMonths: 0,
		extraMonths: 0,
		postFavorableDecisionMonths: 0,
		postDistributionMonthlyCredit: 0,
		postDecisionAmount: 0,
		postDistributionTotalCredit: 0,
		totalBalance: 0,
	}

	formatDate(date) {
		return date.split('-').reverse().join('/')
	}

	formatCNJ(cnj) {
		return tableHelper.formatCNJ(cnj)
	}

	fieldMoneyPortalInput(trial, name, value) {
		const oldValue = trial?.checkingAccounts?.[0]?.[name]
		if (value !== oldValue) {
			this.onInput(trial, name, value)
		}
	}

	async onInput(trial, name, value) {
		onInputCheckingAccounts(
			trial,
			name,
			value,
			this,
			this.updateKeys,
			this.updateMap[name]?.modifies,
		)
	}

	async save(id, obj) {
		const data = await fetch.put('/api/checking-accounts', {
			...obj,
			id,
		})

		return data
	}

	onChangeSelect($event, trial, name) {
		let value = $event.target.value

		if (value === 'true') {
			value = true
		}

		if (value === 'false') {
			value = false
		}

		this.onInput(trial, name, value)
	}

	control = new Control()

	debouncedChange(trial, name, value) {
		const debouncedChange = this.control.debounce(this.onInput, 1000)
		debouncedChange(trial, name, value)
	}
}
